import { useState } from "react";
import { useEffect } from "react";
import NumberStat from "../components/NumberStat";

export default function Stats() {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [totalActivities, setTotalActivities] = useState(0);
    const [totalCompanies, setTotalCompanies] = useState(0);

    useEffect(() => {
        getStats();
    }, []);

    const getStats = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/stats`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('ticino-wild-token')}`
                }
            });
            if (response.ok) {
                const data = await response.json();
                setTotalUsers(data.payload.totalUsers);
                setTotalActivities(data.payload.totalActivities);
                setTotalCompanies(data.payload.totalCompanies);
            } else {
                const error = await response.json();
                setError(error.message || "Errore nella richiesta.");
            }
        } catch (error: any) {
            setError(error.message || "Errore nella richiesta.");
        } finally {
            setIsLoading(false);
        }
    }
    return (
                <div className="bg-white p-5 rounded-lg w-full max-w-[1000px] lg:min-w-[1000px] flex flex-row flex-wrap gap-4">
                    {!isLoading && error && <div className="text-red-500">{error}</div>}
                    {!isLoading && !error && totalUsers > 0 && totalActivities > 0 && (
                        <div className="w-full flex flex-col xl:flex-row items-center gap-y-4 xl:justify-between">
                            <NumberStat title="Utenti" value={totalUsers} icon="fi fi-sr-user" color="blue" />
                            <NumberStat title="Attività" value={totalActivities} icon="fi fi-br-running" color="green" />
                            <NumberStat title="Aziende" value={totalCompanies} icon="fi fi-sr-briefcase" color="yellow" />
                        </div>
                    )}

                </div>
    )
}